import { successToast } from "@/ui/toast/Toast";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";

export function ThankYou() {
	const queryClient = useQueryClient();
	queryClient.invalidateQueries({ queryKey: ["whoami"] });
	queryClient.invalidateQueries({ queryKey: ["courses"] });
	const navigate = useNavigate();
	useEffect(() => {
		successToast("Hvala vam na pretplati!");
		
		// Delayed invalidate to wait for webhooks to process
		setTimeout(() => {
			queryClient.invalidateQueries({ queryKey: ["whoami"] });
			queryClient.invalidateQueries({ queryKey: ["courses"] });
		}, 3000);
		
		navigate("/");
	}, []);
	return <>Hvala vam na pretplati!</>;
}
